import {
  AutocompleteInput,
  ReferenceInput,
  SelectInput,
  TextInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const purchaseOrderFilterList = (permissions) => {
  const defaultFilter = [
    // <TextInput
    //   source="all"
    //   label="mine.filter.search_all"
    //   alwaysOn
    //   resettable
    //   variant="outlined"
    //   InputProps={{
    //     endAdornment: (
    //       <InputAdornment position="end">
    //         <SearchIcon />
    //       </InputAdornment>
    //     ),
    //   }}
    // />,
    <TextInput
      alwaysOn
      source="code"
      label="mine.label.receipt_no"
      resettable
      variant="outlined"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      label="mine.label.start_date"
      variant="outlined"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      label="mine.label.end_date"
      variant="outlined"
      minDateSource="start_date"
    />,
    <ReferenceInput
      alwaysOn
      label="Supplier"
      source="supplier_id"
      reference="suppliers"
    >
      <SelectInput optionText="name" resettable variant="outlined" />
    </ReferenceInput>,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.depo"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};

export default purchaseOrderFilterList;
